import { buildModelsActionCreator } from '../actions';

export const FETCH_LOGIN_MODEL = 'epic.model.FETCH_LOGIN_MODEL';

export type FetchLoginAction = ReturnType<typeof fetchLoginModel>;

export const fetchLoginModel = buildModelsActionCreator(FETCH_LOGIN_MODEL, 'login');
